// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...sanitizeProps(props)}>
    <path d="M19.08 4.93A10 10 0 0 0 3.33 17L2 22.14l5.29-1.39A10 10 0 0 0 12 22a10 10 0 0 0 7.06-17ZM12 20.28a8.37 8.37 0 0 1-4.23-1.15l-.3-.19-3.14.83.84-3.07-.17-.31a8.3 8.3 0 1 1 7 3.89Zm4.55-6.21c-.25-.13-1.48-.73-1.7-.82s-.4-.12-.56.13-.65.81-.79 1a.39.39 0 0 1-.54.06 7.13 7.13 0 0 1-2-1.24 8 8 0 0 1-1.39-1.73c-.14-.25 0-.38.11-.51l.38-.43a1.76 1.76 0 0 0 .24-.42.42.42 0 0 0 0-.43c-.07-.13-.56-1.36-.78-1.86S9.12 7.4 9 7.4h-.51a.94.94 0 0 0-.67.31A2.8 2.8 0 0 0 7 9.76a5 5 0 0 0 1 2.58 11.06 11.06 0 0 0 4.26 3.77 12.07 12.07 0 0 0 1.42.52 3.35 3.35 0 0 0 1.57.1 2.55 2.55 0 0 0 1.68-1.18 2.11 2.11 0 0 0 .15-1.19 1.44 1.44 0 0 0-.51-.29Z" />
  </BaseIcon>
)
